export default function (initialize) {
    const initializer = function () {
        if (!initializer.initialized) {
            initializer.initialized = true;
            initialize();
        }
    };
    return initializer;
}


// WEBPACK FOOTER //
// ./node_modules/linksoft/src/internal/oneTimeInitializer.js